/**
 *  @class
 *  @function RecentlyViewedProducts
 */
if (!customElements.get('recently-viewed-products')) {
  class RecentlyViewedProducts extends HTMLElement {
    constructor() {
      super();

      this.url = theme.routes.search_url + '?view=recently-viewed&type=product&q=';
      this.theme_scroll = this.querySelector('theme-scroll');
      this.container = this.querySelector('.products');
      this.emptyState = this.querySelector('.recently-viewed-empty-state');
      this.currentId = this.dataset.productHandle;
      this.max = this.dataset.count || 5;
      this.products = '';
      if (window.localStorage) {
        let recentIds = window.localStorage.getItem('recently-viewed');
        if (recentIds && typeof (recentIds) !== undefined) {
          window.recentlyViewedIds = JSON.parse(recentIds);
        }
      }
    }
    connectedCallback() {
      this.buildUrl();
    }
    buildUrl() {
      let i = 0;
      window.recentlyViewedIds.forEach((val) => {
        // Skip current product
        if (val === this.currentId) {
          return;
        }
        // Stop at max
        if (i >= this.max) {
          return;
        }
        this.products += 'handle:' + val + ' OR ';
        i++;
      });

      this.url = this.url + encodeURIComponent(this.products);

      this.fetchProducts();
    }
    fetchProducts() {
      fetch(this.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('.products');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.container.innerHTML = recommendations.innerHTML;
            this.classList.add('product-recommendations--loaded');
            this.theme_scroll.init();
            
            // Initialize product cards after AJAX load
            this.querySelectorAll('product-card').forEach(card => {
              if (card.initializeProductCard) {
                card.initializeProductCard();
              }
            });
            
            // Hide empty state if products exist
            if (this.emptyState) {
              this.emptyState.style.display = 'none';
            }

            setTimeout(() => {
              window.dispatchEvent(new Event('resize'));
              if (window.gsap && window.ScrollTrigger) {
                ScrollTrigger.batch(this.container.querySelectorAll('.animations-true .products .product-card--image-primary'), {
                  start: "top 90%",
                  onEnter: (elements) => {
                    gsap.to(elements, { scale: 1, opacity: 1, stagger: 0.15, ease: window.theme.settings.animation_easing });
                  }
                });
              }
            });
          } else {
            // Show empty state if no products
            if (this.emptyState) {
              this.emptyState.style.display = 'block';
              this.style.display = 'block'
            }
            if (this.theme_scroll) {
              this.theme_scroll.style.display = 'none';
            }
          }

        })
        .catch(e => {
          console.error(e);
          // Show empty state on error
          if (this.emptyState) {
            this.emptyState.style.display = 'block';
            this.style.display = 'block'
          }
          if (this.theme_scroll) {
            this.theme_scroll.style.display = 'none';
          }
        });
    }
  }

  customElements.define('recently-viewed-products', RecentlyViewedProducts);
}